import { common } from '../_common.js';
import { stopPropagation } from '../lib/_tool.js';
import { changeURL, disablePage, loadPageContent, closeGlobalNav, pageStatus, loadDetailPage } from './_page_tools.js';
import { modalDetailPage } from './_modal_detail_page.js';
import { loc } from '../lib/_location.js';
import { scroll } from '../lib/_scroll.js';
import { loadFromExternal } from '../lib/_loadPost.js';
import { home } from '../lib/_top.js';
import { philosophy } from '../lib/_philosophy.js';

const $html = document.documentElement;
const hasDetailFolder = ['works', 'people', 'magazine', 'news'];
const needLoadSummary = ['works', 'magazine', 'news'];

class PageTransition {
	constructor(){
		this.current 	= location.href;
		this.next 		= "";
		this.scroll;
		this.isFirst 	= true;
		this.beforePage	= "";
		this.isTop 		= pages.checkIsTop();
		this.scroll = scroll;
		this.scroll.init();
		
		modalDetailPage.init();
	}
	checkURL(event){
		let $this 		= this;
		let $html 		= document.documentElement;
		let $body 		= document.querySelector("body");
		let info 		= loc.all();
		const detailPageLen = 4;
		const pageLen 		= 3;
		const topLen 		= 2;
		console.log("checkURL:", info);
		let folder 			= info.pathArry[1];
		let is_hasDetail 	= hasDetailFolder.includes(folder);
		let is_loadSummary 	= needLoadSummary.includes(folder);
		document.removeEventListener("wheel", stopPropagation, false);
		if( info.pathLen === topLen ){ //トップページ
			console.log("Top Page Root --------------------------");
			closeGlobalNav();
			if( $this.isFirst ){
				$this.isFirst = false;
				$this.afterLoadPage(info, folder);;
			}else{
				disablePage().then( () => {
					if( $body.getAttribute("data-page") != "top" ){
						window.scrollTo(0, 0);
					}
					loadPageContent( info.path, folder ).then( ()=> {
						console.log("end load page");
						$this.afterLoadPage(info, folder);;
					});
				});
			}
			$this.beforePage 	= folder;
		}else if( info.pathLen === detailPageLen ){ //詳細ページからスタート
			console.log("Detail Page Root --------------------------");
			
			if( $html.classList.contains("show_detail") ){
				modalDetailPage.detailModal 	= document.querySelector("[data-page-detail]");
				modalDetailPage.detailContent 	= document.querySelector("[data-content]");
				
				if( $this.isFirst ){
					$this.isFirst = false;
					setTimeout(function(){
						loadFromExternal.init();
					}, 100);
				}else{
					if( $this.beforePage != folder ){ //前のページとカテゴリが違っていたら 例: work > magazine
						disablePage().then( () => {
							console.log("detail > other detail");
							$this.topToDetail(info, folder);
						});
					}else{
						modalDetailPage.detailModal.classList.add("change_detail");
						modalDetailPage.detailContent.addEventListener("transitionend", modalDetailPage.getContent, { 'once': true });
					}
				}
				$this.afterLoadPage(info, folder);;
			}else{ //一覧 > 詳細ページ || 他ページ > TOP
				if( $this.isTop ){
					console.log("TOP > Detail Root -----------------------");
					$this.topToDetail(info, folder);
				}else{
					modalDetailPage.getContent();
					document.querySelector("[data-page-detail]").addEventListener('transitionend', function(){
						$this.afterLoadPage(info, folder);
					}, {
						once: true
					});
				}
			}
			$this.beforePage 	= folder;
			$this.isFirst 		= false;
		}else if( info.pathLen === pageLen ){
			console.log("Other Page Root --------------------------");
			console.log("next:", folder, "before:", $this.beforePage);
			closeGlobalNav();
			let urlInfo = loc.all();
			if( folder === $this.beforePage ){ //同ページ 詳細 > 一覧
				//詳細ページ >　一覧ページ
				if( $html.classList.contains("show_detail") ){
					modalDetailPage.close();
					if( urlInfo.params.category && urlInfo.params.category != "" ){
						filterCategory();
					}else if( urlInfo.params.tag && urlInfo.params.tag != "" ){
						filterTag()
					}
				}else{
					//console.log("ルート1", urlInfo.params);
					if( urlInfo.params.category && urlInfo.params.category != "" ){
						filterCategory();
					}else if( urlInfo.params.tag && urlInfo.params.tag != "" ){
						filterTag()
					}else{
						//カテゴリ絞り込み解除はこっちのルートでしか通らない
						if( Object.values( urlInfo.params ).length === 0 ){
							//console.log("カテゴリ絞り込み解除")
							$body.classList.add("change_category");
							pageStatus.category = "";
							pageStatus.tag 		= "";
							//フィルターの現在地チェック
							filterNav.checkFilterNav("");
							setTimeout(function(){
								loadFromExternal.init();
							}, 200);
						}
					}
				}
				
				
				function filterCategory(){
					//console.log("ルート2");
					pageStatus.category = urlInfo.params.category;
					pageStatus.tag 		= "";
					//フィルターの現在地チェック
					filterNav.checkFilterNav(urlInfo.params.category);
					//loadPost.initをしたい
					$body.classList.add("change_category");
					setTimeout(function(){
						window.scrollTo(0, 0);
						loadFromExternal.init();
					}, 200);
				}
				function filterTag(){
					//console.log("ルート3");
					pageStatus.category = "";
					pageStatus.tag 		= urlInfo.params.tag;
					//フィルターの現在地チェック
					filterNav.checkFilterNav("");
					//loadPost.initをしたい
					$body.classList.add("change_tag");
					setTimeout(function(){
						window.scrollTo(0, 0);
						loadFromExternal.init();
					}, 200);
				}
			}else{
				//console.log("初回アクセス", urlInfo.params);
				//フィルタリング
				if( urlInfo.params.category && urlInfo.params.category != "" && $this.isFirst){
					pageStatus.category = urlInfo.params.category;
					pageStatus.tag 		= "";
					//フィルターの現在地チェック
					filterNav.checkFilterNav(urlInfo.params.category);
					//loadPost.initをしたい
					loadFromExternal.init();
					$this.afterLoadPage(info, folder);
				}else if( urlInfo.params.tag && urlInfo.params.tag != "" && $this.isFirst){
					pageStatus.category = "";
					pageStatus.tag 		= urlInfo.params.tag;
					//フィルターの現在地チェック
					filterNav.checkFilterNav("");
					//loadPost.initをしたい
					loadFromExternal.init();
					$this.afterLoadPage(info, folder);;
				}else{
					//console.log("root1");
					if( $this.isFirst ){
						//console.log("root2");
						$this.isFirst = false;
						if( is_loadSummary ){
							loadFromExternal.init();
						}
						$this.afterLoadPage(info, folder);;
					}else{
						//console.log("root3");
						console.log("pushstate checkURL:", "next>", folder, "before>", $this.beforePage);
						if( folder === $this.beforePage){ //フィルタリングでAllにした時
							//console.log("root4");
							pageStatus.category = "";
							pageStatus.tag 		= "";
							//フィルターの現在地チェック
							filterNav.checkFilterNav(urlInfo.params.category);
							//loadPost.initをしたい
							loadFromExternal.init();
						}else{ //前のページと現在のページが違う場合、ページを読み込み
							//console.log("root5");
							
							//here to go
							
							disablePage().then( () => {
								if( $body.getAttribute("data-page") != "top" ){
									
								}
								window.scrollTo(0, 0);
								loadPageContent( info.path, folder ).then( ()=> {
									console.log("end load page: second");
									if( urlInfo.params.tag && urlInfo.params.tag != ""){
										pageStatus.category = "";
										pageStatus.tag 		= urlInfo.params.tag;
										//フィルターの現在地チェック
										filterNav.checkFilterNav("");
										//loadPost.initをしたい
										loadFromExternal.init();
										$this.afterLoadPage(info, folder);;
									}else{
										$this.afterLoadPage(info, folder);
									}
								});
							});
						}
					}
				}
			}
		}
	}
	afterLoadPage( info, folder ){
		let $this = this;
		let $body = document.querySelector("body");
		//各ページ、フィルターでの変更もここを通る
		$this.isFirst 	= false;
		$this.scroll.reActive();
		$this.beforePage = folder;
		console.log("%cPage Changed: ","color:white; background-color: #3AA6B9; padding:2px; border-radius:2px;", document.querySelector("body").getAttribute("data-page") );
		common.start();
		$this.scroll.setModalDetail();
		home.init();
		philosophy.init();
		modalDetailPage.activeFunc();
		scroll.checkPosition();
		if( $body.classList.contains("disable") ){
			setTimeout(function(){
				$body.classList.remove("disable");
			}, 300);
		}
		setTimeout(function(){
			reActive.nav();
		}, 300)
	}
	topToDetail( info, folder ){
		let $this = this;
		console.log("topToDetail ----------------", info.path);
		disablePage().then( () => {
			window.scrollTo(0, 0);
			loadPageContent( info.path, folder ).then( ()=> {
				//console.log("end load page");
				setTimeout(function(){
					modalDetailPage.open();
					$this.scroll.setModalDetail();
					$this.afterLoadPage(info, folder);
				}, 600);
			});
		});
	}
}

export let pages = {
	router: null,
	init: function(){
		pages.router = new PageTransition();
		pages.router.checkURL();
		let $body = document.querySelector("body");
	
		// popstateイベントリスナーの設定
		window.addEventListener('popstate', function(event) {
			const urlChangeEvent = new Event('urlchange');
			urlChangeEvent.state = event.state;
			window.dispatchEvent(urlChangeEvent)
		});
		
		// カスタムイベントリスナーの設定
		window.addEventListener('urlchange', function(event) {
			//console.log("urlChange:", window.location.href, event.state);
			// 新しい状態に応じた処理を行う関数を呼び出し
			pages.router.checkURL(event.state);
		});
		pages.nav();
	},
	nav: function(){
		let $navs 			= document.querySelectorAll("[data-nav]");
		//summary
		let $peopleLinks 	= document.querySelectorAll(".c-list_people li a");	//people
		let $workLinks 		= document.querySelectorAll(".c-list-works_summaries li a");	//works
		let $magazineLinks	= document.querySelectorAll(".c-list-magazine_summaries li a");	//magazine
		let $newsLinks		= document.querySelectorAll(".c-list-news_summaries li a");	//news
		
		let $links			= document.querySelectorAll("[data-page-detail] a[data-link]");//関連記事等
		let $topLinks		= document.querySelectorAll(`[data-page="top"] a[data-link]`);//関連記事等
		
		let $btnClose		= document.querySelectorAll(`[data-page-detail-close]`);
		let $prevBtn		= document.querySelectorAll(`[data-nav-prev]`);
		let $nextBtn		= document.querySelectorAll(`[data-nav-next]`);
		
		//console.log("data-link > ", $links);
		const eventListeners = [
			{ element: $navs, type: "click", handler: pages.getPageURL},
			
			{ element: $peopleLinks, type: "click", handler: pages.getURL},
			{ element: $workLinks, type: "click", handler: pages.getURL},
			{ element: $magazineLinks, type: "click", handler: pages.getURL},
			{ element: $newsLinks, type: "click", handler: pages.getURL},
			
			{ element: $links, type: "click", handler: pages.getURL},
			{ element: $topLinks, type: "click", handler: pages.getURL},
			
			{ element: $prevBtn, type: "click", handler: pages.getURL},
			{ element: $nextBtn, type: "click", handler: pages.getURL},
			{ element: $btnClose, type: "click", handler: modalDetailPage.back}
		];
		eventListeners.forEach( ( el ) => {
			if(el.element){
				el.element.forEach( ($btn) => {
					$btn.removeEventListener(el.type, el.handler, false);
					$btn.addEventListener(el.type, el.handler, false);
				});
			}
		});
		filterNav.init();
		//console.log("reactive nav", $topLinks);
	},
	getPageURL: function(e){
		e.preventDefault();
		pageStatus.reset();
		changeURL( this.getAttribute("href") ).then( () => {
			
		});
	},
	getURL: function(e){
		e.preventDefault();
		modalDetailPage.beforePage = location.pathname + location.search;
		//console.log("pages getURL", this.getAttribute("href"));
		let $this = this;
		if( $this.getAttribute("data-nav-next") === "" ){
			document.querySelector(".c-loading_detail").classList.add("r");
		}
		pages.router.isTop	= pages.checkIsTop();
		//console.log("current page is TOP?: ", pages.router.isTop);
		changeURL( this.getAttribute("href") ).then( () => {
		
		});
	},
	checkIsTop: function(){
		let path = location.pathname;
		let isTop = false;
		if( path === "/" ){
			isTop = true;
		}
		return isTop;
	}
}

export let reActive = {
	nav: function(){
		pages.nav();
	}
}
export let filterNav = {
	navs: [],
	navsWrap: null,
	select: null,
	hasFilter: false,
	pointer: null,
	init: function(){
		//console.log("active filter nav");
		filterNav.pointer 	= document.querySelector(".c-list_categories .c-active_point");
		filterNav.navs 		= document.querySelectorAll(".c-list_categories li a");
		filterNav.navsWrap 	= document.querySelector(".c-list_categories ul");
		filterNav.select 	= document.querySelector(".c-select_category select");
		filterNav.backToActive();
		//console.log(filterNav.navs);
		if( filterNav.navs.length > 0 ){
			filterNav.hasFilter = true;
			filterNav.navs.forEach( ($nav, index) => {
				$nav.removeEventListener("click", pages.getURL, false);
				$nav.addEventListener("click", pages.getURL, false);
				
				$nav.removeEventListener("mouseenter", { index: index, handleEvent: filterNav.mouseEnter}, false);
				$nav.addEventListener("mouseenter", { index: index, handleEvent: filterNav.mouseEnter}, false);
				//$nav.removeEventListener("mouseleave", { index: index, handleEvent: filterNav.mouseLeave}, false);
				//$nav.addEventListener("mouseleave", { index: index, handleEvent: filterNav.mouseLeave}, false);
			});
			filterNav.navsWrap.removeEventListener("mouseleave", filterNav.mouseLeave, false);
			filterNav.navsWrap.addEventListener("mouseleave", filterNav.mouseLeave, false);
			
			filterNav.select.removeEventListener("change", filterNav.getSelect, false);
			filterNav.select.addEventListener("change", filterNav.getSelect, false);
		}
	},
	getSelect: function(e){
		let filter = this.value;
		changeURL( filter ).then( () => {
			
		});
	},
	changeURL: function(filter){
		pageStatus.reset();
	},
	resetFilter: function(){
		pageStatus.reset().then( () => {
			filterNav.init();
		});
	},
	filterAll: function(){
		pageStatus.reset().then( () => {
			filterNav.init();
		});
	},
	checkFilterNav: function(category){
		filterNav.navs 		= document.querySelectorAll(".c-list_categories li a");
		filterNav.select 	= document.querySelector(".c-select_category select");
		if( category != "" ){
			let currentCategory = "";
			if( !category && filterNav.navs[0] ){
				filterNav.navs[0].classList.add("active");
				filterNav.select.querySelectorAll("option")[0].selected = true;
				
			}
			filterNav.navs.forEach( ($nav, index) => {
				let href = $nav.getAttribute("href");
				let hrefArry = href.split("=");
				if( hrefArry[1] === category ){
					$nav.classList.add("active");
					currentCategory = $nav;
				}else{
					if( $nav.classList.contains("active") ){
						$nav.classList.remove("active");
					}
				}
			});
			
			filterNav.select.querySelectorAll("option").forEach( ($o, index) => {
				let href 		= $o.value;
				let hrefArry 	= href.split("=");
				if( hrefArry[1] === category){
					$o.selected = true;
					currentCategory = $o.innerText;
				}else{
					if( $o.selected ){
						$o.selected = false;
					}
				}
			});
			filterNav.changeTitle(currentCategory);
		}else{
			//console.log("allをクリックしたので解除したい")
			filterNav.navs.forEach( ($nav, index) => {
				if( index === 0 ){
					if( !$nav.classList.contains("active") ){
						$nav.classList.add("active");
						filterNav.resetTitle();
					}
				}else{
					if( $nav.classList.contains("active") ){
						$nav.classList.remove("active");
					}
				}
			});
			
			filterNav.select.querySelectorAll("option").forEach( ($o, index) => {
				if(index === 0){
					if( !$o.selected ){
						$o.selected = true;
						filterNav.resetTitle();
					}
				}else{
					if( $o.selected ){
						$o.selected = false;
					}
				}
			});
		}
	},
	mouseEnter: function(e){
		let $this = e.currentTarget;
		let index = this.index;
		let leftPos = $this.offsetLeft - 15;
		let width 	= $this.clientWidth + 30;
		filterNav.pointer.style.width		= width + "px";
		filterNav.pointer.style.transform 	= `translate3d(${leftPos}px, 0, 0)`;
		//console.log(index, leftPos);
	},
	mouseLeave: function(e){
		filterNav.backToActive();
	},
	backToActive: function(){
		filterNav.navs.forEach( ($n, index) => {
			if( $n.classList.contains("active") ){
				let leftPos = $n.offsetLeft - 15;
				let width 	= $n.clientWidth + 30;
				filterNav.pointer.style.width		= width + "px";
				filterNav.pointer.style.transform 	= `translate3d(${leftPos}px, 0, 0)`;
			}
		});
	},
	changeTitle: function( filtered ){
		let currentTitle 	= document.title;
		let titleArry 		= currentTitle.split("|");
		//console.log(titleArry, titleArry.length);
		let t = "";
		if( titleArry.length >= 3 ){
			titleArry.forEach( (text, index) => {
				if( index === 0 ){
					t += filtered + " | ";
				}else{
					if( index === titleArry.length - 1){
						t += text;
					}else{
						t += text + " | ";
					}
				}
			});
			
		}else{
			t = filtered + " | " + currentTitle;
		}
		document.title = t;
	},
	resetTitle: function(){
		let currentTitle 	= document.title;
		let titleArry 		= currentTitle.split("|");
		let t = "";
		if( titleArry.length >= 3 ){
			titleArry.forEach( (text, index) => {
				if( index === 0 ){
					//t += filtered + " | ";
				}else{
					if( index === titleArry.length - 1){
						t += text;
					}else{
						t += text + " | ";
					}
				}
			});
		}else{
			t = currentTitle;
		}
		document.title = t;
	}
}